import React, { PureComponent } from "react";

import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import moment from "moment";

import { Error, MAIN_COLORS } from "components/Utils/Utils.js";

class WorldCupMatchDataTiming extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  headerFormatter(column, colIndex, index) {
    const columnsToHide = [6, 7, 8];
    const hideColumns = !columnsToHide.includes(colIndex);

    return (
      <div
        style={{
          backgroundColor: MAIN_COLORS[index],
          color: "#fff",
          padding: "5px",
        }}
      >
        {hideColumns && (
          <div
            style={{
              fontSize: "13px",
              textTransform: "uppercase",
              fontFamily: "Museo Slab W01",
              fontWeight: "bold",
            }}
          >
            {column.dataField.split(".")[0].split("_").join(" ")}
          </div>
        )}
        {column.text}
      </div>
    );
  }

  renderTable = (data) => {
    const { title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = [
      {
        dataField: "match",
        text: "Match",
        style: {
          width: "150px",
          minWidth: "150px",
          textAlign: "left",
          fontWeight: "bold",
        },
        headerAlign: "left",
        headerClasses: "sticky-column",
        classes: "sticky-column",
      },
      {
        dataField: "date",
        text: "Date",
        style: { width: "80px", minWidth: "80px" },
        csvFormatter: (_, row) => row && moment(row.date).format("YYYY-MM-DD"),
        headerAlign: "left",
        csvExport: true,
        formatter: (_, row) => {
          return moment(row.date).format("YYYY-MM-DD");
        },
      },
      {
        dataField: "start_time",
        text: "Start Time",
        style: { width: "80px", minWidth: "80px" },
        headerAlign: "left",
      },
      {
        dataField: "game_number",
        text: "Game #",
        align: "center",
        style: { width: "60px", minWidth: "60px" },
        headerAlign: "center",
      },

      {
        dataField: "notes",
        text: "Notes",
        align: "left",
        style: { width: "100px", minWidth: "100px" },
        headerAlign: "left",
      },

      {
        dataField: "delivery.actual",
        text: "Actual",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 0),
      },
      {
        dataField: "delivery.fastie",
        text: "Fastie",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },
        headerAlign: "left",
        align: "center",
        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 0),
      },
      {
        dataField: "delivery.peacock",
        text: "Peacock",
        headerAlign: "left",
        align: "center",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },

        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 0),
      },
      {
        dataField: "delivery.digital",
        text: "Digital",
        headerAlign: "left",
        align: "center",
        style: {
          width: "90px",
          minWidth: "90px",
          backgroundColor: "#f2f2f2",
        },

        headerFormatter: (column, colIndex) =>
          this.headerFormatter(column, colIndex, 0),
      },
    ];

    const filename = title.split(" ").join("_") || "spreadsheet";

    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={columns}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  };

  builtInExportCSV = () => this.childRef;

  render() {
    const data = this.props.data.data;

    if (data.hasData === false) {
      return <Error minHeight={560} />;
    }

    return (
      <div className="world-cup-actual-estimates-table">
        {this.renderTable(data)}
      </div>
    );
  }
}

export default WorldCupMatchDataTiming;
